export enum ChangeRequestStatus {
  DRAFT = "DRAFT",
  PARTIALLY_APPLIED = "PARTIALLY_APPLIED",
  APPROVED = "APPROVED",
  DISCARDED = "DISCARDED",
}
